import { useEffect, useState } from "react";
import { Bell, BellRing, Share, SquarePlus, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { pushAvailability, pushStatus, subscribePush } from "@/lib/push";
import { Reveal, Eyebrow } from "./Reveal";

export const InstallSteps = () => (
  <ol data-testid="push-install-steps" className="space-y-2.5 text-sm text-zinc-300">
    <li className="flex items-center gap-3"><Share className="h-4 w-4 shrink-0 text-white" /> 1. No Safari, toque em <b className="text-white">Compartilhar</b></li>
    <li className="flex items-center gap-3"><SquarePlus className="h-4 w-4 shrink-0 text-white" /> 2. Escolha <b className="text-white">Adicionar à Tela de Início</b></li>
    <li className="flex items-center gap-3"><Smartphone className="h-4 w-4 shrink-0 text-white" /> 3. Abra o app <b className="text-white">RC iPhones</b> e ative os alertas</li>
  </ol>
);

export const pushErrorText = (e) => (e?.message === "denied"
  ? "Notificações bloqueadas. Libere nos Ajustes do celular para este site."
  : "Seu navegador não aceita notificações. Tente pelo Chrome ou Safari atualizado.");

export const usePushStatus = () => {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (pushAvailability() !== "ok") return;
    pushStatus().then(setStatus).catch(() => setStatus(null));
  }, []);
  return [status, setStatus];
};

export const AlertsSection = () => {
  const [status, setStatus] = usePushStatus();
  const [busy, setBusy] = useState(false);
  const avail = pushAvailability();
  const on = !!status?.notify_all;

  const toggle = async () => {
    setBusy(true);
    try {
      setStatus(await subscribePush({ notify_all: !on }));
      toast.success(on ? "Alertas desativados" : "Pronto! Você será avisado das novidades.");
    } catch (e) {
      toast.error(pushErrorText(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="alertas" data-testid="alerts-section" className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:py-24">
      <Reveal>
        <div className="grid gap-8 rounded-[32px] border border-white/10 bg-[#111113] p-6 sm:p-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-7">
            <Eyebrow>Alertas no celular</Eyebrow>
            <h2 className="font-display mt-4 text-3xl font-extrabold tracking-[-0.03em] text-white sm:text-5xl">Saiba primeiro quando baixar o preço.</h2>
            <p className="mt-4 max-w-lg text-zinc-300">Receba uma notificação quando um iPhone baixar de preço ou chegar no estoque. Sem cadastro.</p>
          </div>
          <div className="lg:col-span-5">
            {avail === "ios-install" && <InstallSteps />}
            {avail === "unsupported" && <p className="text-sm text-zinc-400">Este navegador não aceita notificações. Abra o site pelo Chrome (Android) ou adicione à Tela de Início no iPhone.</p>}
            {avail === "ok" && (
              <button data-testid="alerts-toggle" onClick={toggle} disabled={busy}
                className={`flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-sm font-semibold transition-colors active:scale-95 ${on ? "border border-white/20 text-white hover:bg-white/10" : "bg-white text-black hover:bg-zinc-200"}`}>
                {on ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
                {busy ? "Aguarde…" : on ? "Alertas ativados · desativar" : "Ativar alertas"}
              </button>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
